























































































import { PasswordValidationError } from '../authentication-model'
import { openLinkInNewTab } from '@/router'
import { isPosteTheme } from '@/components/RenderWithTheme.vue'

export default {
  props: {
    isSubmitting: { type: Boolean, required: true },
    onValidation: { type: Function, required: true },
    isForgottenPassword: { type: Boolean, default: false }
  },
  data() {
    return {
      password: '',
      confirmedPassword: '',
      popoverOpen: false,
      validationErrors: [],
      agreedToTermsAndConditions: false,
      errorMessage: '',
      agreedToReceiveNewsletter: false
    }
  },
  computed: {
    isPosteTheme() {
      return isPosteTheme
    },
    passwordRequirements() {
      return {
        [this.$t('registration.passwordSetupForm.minLength', { minLength: 8 })]: this
          .passwordIsLongEnough,
        [this.$t('registration.passwordSetupForm.tooSimilar')]:
          this.passwordIsLongEnough &&
          !this.validationErrors.includes(PasswordValidationError.TooSimilar),
        [this.$t('registration.passwordSetupForm.tooCommon')]:
          this.passwordIsLongEnough &&
          !this.validationErrors.includes(PasswordValidationError.TooCommon),
        [this.$t('registration.passwordSetupForm.entirelyNumeric')]:
          this.passwordIsLongEnough &&
          !this.validationErrors.includes(PasswordValidationError.EntirelyNumeric)
      }
    },
    passwordIsLongEnough() {
      return this.password.length >= 8
    },
    passwordIsValid() {
      const isStrong = Object.values(this.passwordRequirements).every(value => value)
      const isConfirmed = this.password === this.confirmedPassword
      return isStrong && isConfirmed
    },
    buttonText() {
      return this.isForgottenPassword
        ? this.$t('registration.passwordSetupForm.buttonReset')
        : this.$t('registration.passwordSetupForm.buttonSignUp')
    },
    passwordInputTitle() {
      return this.isForgottenPassword
        ? this.$t('registration.passwordSetupForm.buttonNewPassword')
        : this.$t('registration.passwordSetupForm.buttonPassword')
    }
  },
  methods: {
    onFocus() {
      this.popoverOpen = true
    },
    onBlur() {
      this.popoverOpen = false
    },
    async onChange() {
      if (this.passwordIsLongEnough) {
        this.validationErrors = await this.onValidation(this.password)
      }
    },
    onSubmit() {
      if (
        this.passwordIsValid &&
        (this.isForgottenPassword || this.agreedToTermsAndConditions)
      ) {
        this.$emit('submit', {
          newPassword1: this.password,
          newPassword2: this.confirmedPassword,
          agreedToReceiveNewsletter: this.agreedToReceiveNewsletter
        })
      } else if (!this.isForgottenPassword && !this.agreedToTermsAndConditions) {
        this.errorMessage = this.$t('registration.errorMessages.termsNotAccepted')
      }
    },
    validatePasswordConfirmation() {
      return (
        this.password &&
        this.confirmedPassword &&
        this.password !== this.confirmedPassword
      )
    },
    goToTermAndConditions() {
      openLinkInNewTab('https://www.sennder.com/terms-conditions')
    },
    goToParticipationAndUse() {
      openLinkInNewTab('https://www.sennder.com/orcas/terms-conditions')
    },
    goToPrivacyPolicy() {
      openLinkInNewTab('https://www.sennder.com/orcas/privacy-policy')
    }
  }
}
